import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1db8ac83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scene" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, /*#__PURE__*/_toDisplayString('随着企业数字化业务的不断膨胀，云成本迅速增长，亟需对云上成本进行优化管理。'
          +'麦肯锡的一份调查则显示：与单纯利用公有云的方案相比，混合云可以帮助客户提高2.5倍的业务价值，这进一步加强了企业迈向混合云部署的期待。'), -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"10px"} }, /*#__PURE__*/_toDisplayString('星汉未来应市场需求，推出运维托管解决方案。'
          +'通过提供“混合云托管”、“Serverless托管”等两种模式，全面帮助企业大幅降低IT成本。'), -1 /* HOISTED */))
const _hoisted_5 = { class: "solution" }
const _hoisted_6 = { class: "solution_title" }
const _hoisted_7 = {
  key: 0,
  class: "solution_title-line_left"
}
const _hoisted_8 = {
  key: 1,
  class: "solution_title-line_right"
}
const _hoisted_9 = { class: "solution_content" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = { class: "image" }
const _hoisted_12 = { class: "item_discount" }
const _hoisted_13 = { class: "item_discount-div" }
const _hoisted_14 = { class: "item_discount-div" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 折 ", -1 /* HOISTED */))
const _hoisted_16 = { class: "solution_server" }
const _hoisted_17 = { class: "solution_server-item_title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, {
        level: 1,
        style: {"margin-bottom":"20px"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 方案价值 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_typography_paragraph, null, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_a_typography_title, { level: 1 }, {
          default: _withCtx(() => [
            _createTextVNode(" 星汉未来运维托管解决方案 ")
          ]),
          _: 1 /* STABLE */
        }),
        (_ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_a_row, { gutter: [60,30] }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.list, (item, index) => {
              return (_openBlock(), _createBlock(_component_a_col, {
                key: index,
                xs: 24,
                md: 12,
                xl: 12
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(item.title), 1 /* TEXT */),
                    _createVNode(_component_a_typography_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, _toDisplayString(item.text), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", null, _toDisplayString(item.discount), 1 /* TEXT */),
                            _hoisted_15
                          ])
                        ])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */),
                    _createVNode(_component_a_typography_paragraph, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (v) => {
                          return (_openBlock(), _createElementBlock("p", {
                            class: "item_list",
                            key: v
                          }, _toDisplayString(v), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ])
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_a_row, { gutter: [150,30] }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.list2, (item, index) => {
              return (_openBlock(), _createBlock(_component_a_col, {
                key: index,
                xs: 24,
                md: 12,
                xl: 12
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass('solution_server-item_'+index)
                  }, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(item.title), 1 /* TEXT */),
                    (index===0)
                      ? (_openBlock(), _createBlock(_component_a_typography_paragraph, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.text), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */))
                      : (_openBlock(), _createBlock(_component_a_typography_paragraph, { key: 1 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (v) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "item_list",
                                key: v
                              }, _toDisplayString(v), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */))
                  ], 2 /* CLASS */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        })
      ])
    ])
  ]))
}